<template>
    <div class="wrapper">
        <dashboard-bar refreshButton />
        <div class="body">
            <div class="row no-gutters">
                <div class="col-lg-12">
                    <span class="header-icon">
                        <font-awesome-icon :icon="['fas', 'sync-alt']" />
                    </span>
                    <h2>{{ $t('menu.sidebar.treatmentsReview') }}</h2>
                </div>
                <treatment-table />
            </div>
        </div>
    </div>
</template>
  
<script>
import treatmentTable from '@/components/organisms/treatments/treatments-revision/treatment-table';
import dashboardBar from '@/components/molecules/dashboard-bar';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
    components: { treatmentTable, dashboardBar },

    computed: {
        ...mapState('authentication', ['userProfile']),
        ...mapFields('companies', ['company']),
    },

    data: () => ({
        userAuth: null,
    }),

    async created() {
        this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

        if (!this.userProfile.permissions.treatments.menu) {
            this.$router.push(`/dashboard/${this.userAuth.companyId}`);
        }

        await this.getCompany({
            id: this.userAuth.companyId,
            token: this.userAuth.token,
        });


        if(!this.company.enableTreatmentRevision){
            this.$router.push(`/dashboard/${this.userAuth.companyId}`);
        } else if (this.company.enableTreatmentRevision && !this.userProfile.permissions.treatments.revision) {
            this.$router.push(`/dashboard/${this.userAuth.companyId}`);
        }
    },

    methods: {
        ...mapActions('companies', ['getCompany']),
    }
};
</script>
  
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
    padding: 8px;
}

.refresh-icon {
    cursor: pointer;
    color: $primary;

    &:hover {
        color: rgb(97, 209, 97);
    }
}

.body {
    background-color: $white;
    padding: 16px;
    border: 1px solid $gray-light;
    border-radius: 4px;
}

.body h2 {
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 100;
    color: $gray;
}

.header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
}

.input-area {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    select {
        max-width: 300px;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/organisms/treatments/treatments-revision/index.vue